import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';

const { Search } = Input;

@inject('BookingSubCategoryStore')
@observer
class BookingSubCategorySearchModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('Category'),
                dataIndex: 'name',
                key: 'name',
                width: '80%'
            },
            {
                title: t('Action'),
                dataIndex: 'id',
                key: 'id',
                width: '20%',
                render: id => (
                    <span>
                        <Button onClick={() => this.selectBookingCategoryOnClick(id)} type='primary'>
                            {t('Select')}
                        </Button>
                    </span>
                ),
            },
        ]
    }

    // ON CHANGE

    itemOnChange = e => {
        this.props.BookingSubCategoryStore.setBookingCategorySearchValue(e.target.value);
        this.props.BookingSubCategoryStore.searchBookingCategory();
    }

    // ON CLICK

    selectBookingCategoryOnClick = taskId => {
        this.props.BookingSubCategoryStore.searchBookingCategorySelected(taskId);
        this.props.BookingSubCategoryStore.setShowBookingCategorySearchModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            lastChildBookingCategoryFilter,
            bookingCategorySearchValue
        } = this.props.BookingSubCategoryStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder={t('Search Category')} value={bookingCategorySearchValue} onChange={this.itemOnChange} />
                <Table columns={this.getColumns()} dataSource={lastChildBookingCategoryFilter} />
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(BookingSubCategorySearchModalPage);
